import { render, staticRenderFns } from "./PartnerManageStepperKSRView.vue?vue&type=template&id=c10a008a&"
import script from "./PartnerManageStepperKSRView.vue?vue&type=script&lang=ts&"
export * from "./PartnerManageStepperKSRView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports